import React from "react";
import { Nav, Navbar, Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logout from "./auth/Logout";
import { endpoint } from "../utils/api";
import { Zoom } from "./Zoom";
import Logo from './assets/MA Logo-no text.png'

export const NavBar = () => {
  const manager = () => {
    window.open('https://www.mach-intranet.com/templates', '_blank');
  }
  return (
    <div >
      <Navbar bg="dark" variant="dark" className="navbar" expand="md">     
      <Nav className="me-auto nav-1" variant="tabs" defaultActiveKey="/templates"  >   
      <Navbar.Brand className="nav-logo">
      <img
        src={Logo}
        width="30"
        height="30"
        className="d-inline-block align-top"
        alt=""
      />
    </Navbar.Brand>        
        <Nav.Item className="nav-item">
          <Nav.Link as={Link} to="/reports">
            New Report
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="nav-item">
          <Nav.Link as={Link} to="/templates">
            Templates
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="nav-item">
          <Nav.Link as={Link} to="/sections">
            Sections
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="nav-item">
        <Nav.Link onClick={() => manager()}>
            Manager
          </Nav.Link>
        </Nav.Item>

        {/* <Nav.Item>
          <Nav.Link as={Link} to="/examples">
            Examples
          </Nav.Link>
        </Nav.Item> */}
        </Nav>

        <Navbar.Toggle aria-controls="navbarScroll" className="navbar-toggler" />
        <Navbar.Collapse id="navbarScroll">
        <Nav className="me-auto nav-2 " variant="tabs" defaultActiveKey="/templates" >
        <Nav.Item>
          <Zoom />
        </Nav.Item> 
        <Nav.Item>
        <Logout className="logout" />
        </Nav.Item>  
    
      </Nav> 
      </Navbar.Collapse>
      </Navbar>     
 </div>
    
  );
};
